import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import AccordionItem from './AccordionItem'
import { FAQPageJsonLd } from 'next-seo'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { addHyperlinkTitle } from '../../../../../common/helpers'
import classNames from 'classnames'

const sleep = (ms) => new Promise((r) => setTimeout(r, ms))

const Accordion = ({
  items,
  title,
  titleCenter,
  questionClassName,
  answerClassName,
  titleClassName,
  showFirstDivider,
}) => {
  const itemRefs = useRef([])
  const [marked, setMarked] = useState()
  const handleChangeCollapse = async (id) => {
    if (id === marked) {
      setMarked(undefined)
    } else {
      setMarked(id)
      if (itemRefs.current[id - 1]) {
        await sleep(200)
        itemRefs.current[id - 1].scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  const JsonLdData = items.map((item) => ({
    questionName: item.title,
    acceptedAnswerText: documentToHtmlString(item.content).replace(/"/g, "'"),
  }))

  if (!(items.length > 2)) return null

  return (
    <div data-testid="faq-accordion">
      <FAQPageJsonLd mainEntity={JsonLdData} />
      <div className="px-5 py-10 lg:px-2 lg:py-8">
        {title ? (
          <div
            data-testid="accordion-title"
            className={classNames(
              'mb-3 text-[#1F1F23] lg:mb-6',
              titleCenter && 'text-center',
              titleClassName
            )}
          >
            {title}
          </div>
        ) : null}
        <div data-testid="item-list" className="border-b border-gray-540">
          {items.map((f, i) => {
            const { title: question, content } = f

            addHyperlinkTitle(content?.content, question)

            return (
              <div ref={(el) => (itemRefs.current[i] = el)} key={i}>
                <AccordionItem
                  title={question}
                  content={content}
                  id={i}
                  opened={marked === i}
                  changeCollapse={handleChangeCollapse}
                  questionClassName={questionClassName}
                  answerClassName={answerClassName}
                  showFirstDivider={showFirstDivider}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

Accordion.defaultProps = {
  items: [],
  titleCenter: false,
  titleClassName:
    'text-1.5xl lg:text-3.5xl lg:leading-primary-xs lg:text-gray-910',
  showFirstDivider: false,
}
Accordion.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  titleCenter: PropTypes.bool,
  questionClassName: PropTypes.string,
  answerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  showFirstDivider: PropTypes.bool,
}

export default Accordion
